export default {"src":"/_next/static/media/portal.6c2c06dd.svg","height":404,"width":1440};